export function dataInRequest(params = {}) {
  return {
    type: '@justificativaTrocaModoOperacional/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@justificativaTrocaModoOperacional/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@justificativaTrocaModoOperacional/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@justificativaTrocaModoOperacional/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@justificativaTrocaModoOperacional/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@justificativaTrocaModoOperacional/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@justificativaTrocaModoOperacional/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@justificativaTrocaModoOperacional/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@justificativaTrocaModoOperacional/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@justificativaTrocaModoOperacional/RECORD_FILTERING',
    payload: { params },
  };
}
